/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Caption_Track_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Select a caption track" |
*
* @param {Embed_Captions_Caption_Track_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_caption_track_placeholder = /** @type {((inputs?: Embed_Captions_Caption_Track_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Caption_Track_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Selectionnez une piste de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie eine Untertitelspur aus.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una traccia di sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выберите дорожку субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar una pista de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("选择字幕轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕トラックを選択")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन ट्रैक चुनें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Selecione uma faixa de legenda.")
	return /** @type {LocalizedString} */ ("Select a caption track")
});